webpackJsonp([3],{

/***/ 2128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__domain_grv_services__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BloquearGrvLeilaoAlerta',
  props: {
    grvId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      atualizadoSucesso: false,
      cadastroError: null,
      isLoaded: false,
      data: { lotes: [] },
      motivoBloqueio: null
    };
  },

  computed: {
    impedirBloqueio: function impedirBloqueio() {
      return false;
    },
    isSemMotivo: function isSemMotivo() {
      return !(this.motivoBloqueio || '').length;
    },
    hasParentLoading: function hasParentLoading() {
      return this.$parent && typeof this.$parent.loading === 'function';
    },
    isBloqueado: function isBloqueado() {
      return this.data.bloqueado;
    }
  },
  created: function created() {
    this.load();
  },

  methods: {
    load: function load() {
      var _this = this;

      this.setParentLoading(true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__domain_grv_services__["D" /* checarInformacoesBloqueioGrv */])(this.grvId).then(function (result) {
        _this.data = result.data;
        _this.motivoBloqueio = _this.data.motivo;
        console.log(result.data);
      }).catch(function (error) {
        alert('Erro ao carregar as informações de exclusão');
        console.log(error);
      }).finally(function () {
        _this.isLoaded = true;
        _this.setParentLoading(false);
      });
    },
    bloquearGrvParaLeilao: function bloquearGrvParaLeilao() {
      var _this2 = this;

      var acao = this.isBloqueado ? 'desbloqueio' : 'bloqueio';
      if (this.isSemMotivo) return alert('Explique o motivo para o ' + acao + ' desta GRV.');
      var confirmar = confirm('Confirmar ' + acao + '?');
      if (!confirmar) return;
      this.setParentLoading(true);
      if (this.isBloqueado) {
        this.motivoBloqueio = null;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__domain_grv_services__["E" /* bloquearParaLeilao */])(this.grvId, !this.isBloqueado, this.motivoBloqueio).then(function (result) {
        _this2.$emit('finishSubmit');
        _this2.atualizadoSucesso = true;
      }).catch(function (error) {
        alert('Erro ao efetuar operação');
        console.log(error);
        _this2.cadastroError = error.data.errors;
      }).finally(function () {
        _this2.setParentLoading(false);
      });
    },
    setParentLoading: function setParentLoading(option) {
      this.hasParentLoading && this.$parent.loading(option);
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    }
  }
});

/***/ }),

/***/ 2155:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2108)(true);
// imports


// module
exports.push([module.i, ".lista-efeitos-colaterais li[data-v-7c4fbfdf]:before{content:\"=> \";font-weight:700}", "", {"version":3,"sources":["/opt/buildhome/repo/src/app/website/grvs/components/BloquearGrvLeilaoAlerta.vue"],"names":[],"mappings":"AACA,qDACE,cAAe,AACf,eAAkB,CACnB","file":"BloquearGrvLeilaoAlerta.vue","sourcesContent":["\n.lista-efeitos-colaterais li[data-v-7c4fbfdf]::before {\n  content: '=> ';\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2167:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2109)("8afc45e0", content, true, {});

/***/ }),

/***/ 2193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded && !_vm.atualizadoSucesso) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Bloqueio de GRV para leilão")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao bloquear GRV")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Excluído com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Atenção!")]), _vm._v(" "), (_vm.isBloqueado) ? _c('small', [_vm._v("A GRV foi bloqueada para leilões em " + _vm._s(_vm._f("formatDate")((_vm.data.dataBloqueio ? _vm.data.dataBloqueio.date : null), 'DD/MM/YYYY HH:mm')) + " pelo seguinte motivo:\n            "), _c('br'), _c('br'), _vm._v("\n            " + _vm._s(_vm.motivoBloqueio) + "\n          ")]) : _c('small', [_vm._v("A GRV selecionada não poderá ser utilizada para criação de lote.")]), _vm._v(" "), (_vm.data.lotes.length) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('h4', {
    staticClass: "m-b-lg"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle text-danger"
  }), _vm._v(" Esta GRV está ligada aos seguintes leilões:")]) : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled l-h-2x"
  }, _vm._l((_vm.data.lotes), function(lote) {
    return _c('li', [_vm._v("Lote "), _c('strong', [_vm._v(_vm._s(lote.lote))]), _vm._v(" no leilão "), _c('strong', [_vm._v(_vm._s(lote.tituloLeilao))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.isBloqueado) ? _c('hr') : _vm._e(), _vm._v(" "), (!_vm.impedirBloqueio && !_vm.isBloqueado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.motivoBloqueio),
      expression: "motivoBloqueio",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "rows": "4",
      "placeholder": "Motivo do bloqueio"
    },
    domProps: {
      "value": (_vm.motivoBloqueio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivoBloqueio = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.impedirBloqueio) ? _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-auto btn-danger m-r-xs",
    attrs: {
      "disabled": _vm.isSemMotivo
    },
    on: {
      "click": _vm.bloquearGrvParaLeilao
    }
  }, [(_vm.isBloqueado) ? _c('span', [_vm._v("Desbloquear")]) : _c('span', [_vm._v("Confirmar bloqueio")])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1) : _vm._e()])])])]) : (_vm.atualizadoSucesso) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x text-success"
  }), _vm._v(" "), _c('h4', {
    staticClass: "m-t-lg"
  }, [_vm._v("Grv bloqueada com sucesso!")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(2167)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(2128),
  /* template */
  __webpack_require__(2193),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c4fbfdf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.ccfd35e676a4113caf18.js